import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-37-visakh-sasikumar-guest.webp";
import ThumbImg from "../../assets/images/conversations/037.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: fn-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .fn-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .fn-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .fn-hero { padding-top: 60px; padding-bottom: 60px; }
  .fn-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .fn-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .fn-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .fn-hero__title.fn-visible { opacity: 1; transform: translateY(0); }
  .fn-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .fn-hero__spotify.fn-visible { opacity: 1; transform: translateY(0); }
  .fn-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .fn-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .fn-hero__right.fn-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .fn-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .fn-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .fn-yt-thumb:hover img { opacity: 0.85; }
  .fn-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .fn-yt-thumb__play img { width: 40px; height: 44px; }
  .fn-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .fn-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .fn-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .fn-body.fn-visible { opacity: 1; transform: translateY(0); }
  .fn-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .fn-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .fn-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .fn-guest.fn-visible { opacity: 1; transform: translateY(0); }
  .fn-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .fn-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .fn-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .fn-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .fn-inner { padding-left: 32px; padding-right: 32px; }
    .fn-hero { padding-top: 32px; padding-bottom: 48px; }
    .fn-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .fn-hero__title { font-size: 24px; }
    .fn-hero__left { gap: 16px; }
    .fn-guest__title { font-size: 24px; margin-bottom: 24px; }
    .fn-guest__photo-bg { width: 260px; height: 300px; }
    .fn-guest__name { font-size: 24px; margin-top: 18px; }
    .fn-body__para { font-size: 14px; margin-bottom: 12px; }
    .fn-body { padding-bottom: 48px; }
    .fn-guest { padding-bottom: 48px; }
    .fn-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .fn-inner { padding-left: 16px; padding-right: 16px; }
    .fn-hero { padding-top: 51px; padding-bottom: 30px; }
    .fn-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .fn-hero__left { gap: 30px; }
    .fn-hero__title { font-size: 30px; }
    .fn-body__para { font-size: 16px; margin-bottom: 10px; }
    .fn-guest__title { font-size: 30px; margin-bottom: 20px; }
    .fn-guest__photo-bg { width: 100%; height: 386px; }
    .fn-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .fn-body { padding-bottom: 30px; }
    .fn-guest { padding-bottom: 30px; }
    .fn-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fn-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "c66Zjk0iu6A";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="fn-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 37 Fyn"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="fn-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 37 Fyn thumbnail" />
      <div className="fn-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="fn-hero">
      <div className="fn-inner">
        <div className="fn-hero__grid">
          <div className="fn-hero__left">
            <h1 ref={titleRef} className="fn-hero__title">
              EP 37 | Rediscovering Sustainable Last Mile Logistics | Fyn
            </h1>
            <div ref={spotifyRef} className="fn-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0iFbh58w9ciqCZDqHXSXUP?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 37 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="fn-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="fn-body">
      <div className="fn-inner">
        <p className="fn-body__para">
          In this episode, we hit the road and have a conversation with Visakh Sasikumar, an entrepreneur who co-founded Fyn, a startup focused on end-to-end micro-electric mobility. Their approach involves leveraging data to enhance productivity during the last mile of delivery. Visakh, an alumnus of IIT Madras, envisions making last-mile zero-emission mobility more efficient through complete digitization. By blending technology with execution, he aims to facilitate rapid scale-up. Currently, he is actively involved in building India's largest vertically integrated electric vehicle ecosystem platform, catering to both last-mile logistics and commute applications.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="fn-guest">
      <div className="fn-inner">
        <h2 className="fn-guest__title">Our Guest</h2>
        <div>
          <div className="fn-guest__photo-bg">
            <img src={GuestImg} alt="Vikas Sasikumar" />
          </div>
          <p className="fn-guest__name">Vikas SASIKUMAR</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep37Fyn() {
  return (
    <>
      <style>{CSS}</style>
      <div className="fn-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}